module.exports = __webpack_public_path__ + "static/media/location_32_blue.112f92d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/location_32_blue.svg
// module id = 617
// module chunks = 0